import React, { useCallback, useEffect, useState, useRef } from "react";
import _ from "lodash";
import { convertHexToRGBA, filterSections } from "../../utils";
import { UNIT, SECTION_UPDATE_INTERVAL } from "../../constants";
import { getNewSections, updateMsgSectionRange } from "./ListProduct.services";
import { useAppSelector } from "../../redux/hook";
import ProductList from "./components/ProductList";
import {
  analyticsEvents,
  PAGES,
  PROVENANCE,
} from "../../utils/firebaseAnalytics";
import { SectionHeader } from "@dishopsaas/design-system";
import { Typography } from "@mui/material";

export default function ListProduct({ setSelectedSection, isMobile }) {
  const [messages, setMessages] = useState({});
  const [newSections, setNewSections] = useState([]);
  const { productOffers } = useAppSelector((state) => state.offerReducer);
  const { isHorizontalSection } = useAppSelector(
    (state) => state.componentReducer,
  );
  const { sections } = useAppSelector((state) => state.shopReducer);

  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer,
  );
  const intervalRef = useRef(null);
  const lastActiveRef = useRef(null);

  useEffect(() => {
    const offset = isMobile ? 200 : isHorizontalSection ? 140 : 95;
    let ticking = false;

    const computeActive = () => {
      const els = document.querySelectorAll(".target-section");
      if (!els.length) return;

      let activeEl = els[0];
      for (const el of els) {
        if (el.getBoundingClientRect().top <= offset) {
          activeEl = el;
        } else {
          break;
        }
      }

      const key = activeEl.id.replace("section-", "");
      if (lastActiveRef.current !== key) {
        lastActiveRef.current = key;
        setSelectedSection(key);
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        computeActive();
        ticking = false;
      });
    };

    computeActive();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [setSelectedSection, isMobile, newSections]);

  useEffect(() => {
    analyticsEvents.logPageViewEvent(PAGES.PRODUCT, PROVENANCE.MENU_PAGE);
  }, []);

  useEffect(() => {
    setNewSections(getNewSections(productOffers, filterSections(sections)));
  }, [sections, productOffers]);

  useEffect(() => {
    const shouldUpdateSections = (sections) => {
      return _.some(sections, (section) => section?.activationRange);
    };

    const updateAndFilterSections = () => {
      if (shouldUpdateSections(sections)) {
        updateMsgSectionRange(newSections, messages, setMessages);
        setNewSections(getNewSections(productOffers, filterSections(sections)));
      }
    };
    updateAndFilterSections();

    if (shouldUpdateSections(sections)) {
      intervalRef.current = setInterval(
        updateAndFilterSections,
        SECTION_UPDATE_INTERVAL,
      );
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [sections, messages, productOffers]);

  return (
    <div id="list-products" className="col" style={{ paddingBottom: "30vh" }}>
      {_.isEmpty(newSections) && (
        <div>
          <SectionHeader isLoading description />
          <ProductList isLoading section={null} messages={null} />
        </div>
      )}

      {_.map(newSections, (section) => {
        if (!section || section.hidden || section.isPrivate) {
          return null;
        }
        const message = messages[section.key];

        return (
          <div
            key={section.key}
            id={`section-${section.key}`}
            className="target-section"
          >
            <SectionHeader
              iconUrl={section.iconUrl}
              title={section.name}
              description={section.description}
            />
            {message && (
              <Typography
                variant="body1"
                style={{
                  backgroundColor: convertHexToRGBA(secondaryColor, 0.2),
                  textAlign: "center",
                  color: secondaryColor,
                  fontSize: 14,
                  padding: UNIT * 0.8,
                  marginBottom: 16,
                }}
              >
                {`Les produits de ${section.name} seront bientôt disponibles. La prochaine plage d'activation est ${message}.`}
              </Typography>
            )}
            <div style={{ marginBottom: 16 }}>
              <ProductList section={section} messages={messages} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
